import { render, staticRenderFns } from "./SharedVendorSelector.vue?vue&type=template&id=4e55a31e"
import script from "./SharedVendorSelector.vue?vue&type=script&lang=ts"
export * from "./SharedVendorSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports